module.exports = __webpack_public_path__ + "img/programs-icon-3.f1f14ece.png";